import { type ReactElement, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import type { ReviewsDistribution } from '@/features/memberReviews/memberReviews.types'
import { Dialog } from 'ui/src/components/Dialog/Dialog'
import { CrossIcon } from 'ui/src/icons/CrossIcon'
import { yStack } from 'ui/src/patterns/stack'
import { ReviewsDistributionByScore } from './ReviewsDistributionByScore'
import { dialogCloseBtn, dialogContent, dialogWindow } from './dialogStyles.css'

type Props = {
  reviewsDistribution: ReviewsDistribution
  children: ReactNode
  Header?: ReactElement
  onClose?: () => void
}

export function ReviewsDistributionDialog({ reviewsDistribution, children, onClose, Header }: Props) {
  const { t } = useTranslation()
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild={true}>{children}</Dialog.Trigger>

      <Dialog.Content className={dialogContent} centerContent={true} onClose={onClose}>
        <Dialog.Close className={dialogCloseBtn} onClick={onClose} aria-label={t('DIALOG_CLOSE')}>
          <CrossIcon size="1rem" />
        </Dialog.Close>

        <Dialog.Window className={dialogWindow}>
          <div className={yStack({ gap: 'xl' })}>
            {Header}

            <section>
              {reviewsDistribution.map(([score, percentage]) => (
                <ReviewsDistributionByScore key={score} score={score} percentage={percentage} />
              ))}
            </section>
          </div>
        </Dialog.Window>
      </Dialog.Content>
    </Dialog.Root>
  )
}
